import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, CircleDashed, Lock } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { nextOpenSteps, useOnboarding } from '../contexts/OnboardingContext';

const STATUS_ICON = { done: CheckCircle2, blocked: Lock };

// "Getting started" card on the Dashboard (styles in Dashboard.css). Hidden when the checklist
// is unavailable, complete or dismissed.
function OnboardingCard() {
  const { user } = useAuth();
  const { data, setDismissed } = useOnboarding();
  if (!data || data.complete || data.dismissed) return null;

  const steps = nextOpenSteps(data, 3);
  return (
    <section className="dashboard-card onboarding-card" aria-label="Getting started">
      <div className="onboarding-head">
        <h3 className="card-title">Getting started</h3>
        <span className="onboarding-count">{data.required_done} of {data.required_total} done</span>
      </div>
      <progress
        className="onboarding-progress"
        max={data.required_total}
        value={data.required_done}
        aria-label={`${data.required_done} of ${data.required_total} setup steps done`}
      />
      <ul className="onboarding-step-list">
        {steps.map((s) => {
          const Icon = STATUS_ICON[s.status] || CircleDashed;
          return (
            <li key={s.id}>
              <Link to={s.route} className={`onboarding-step onboarding-step--${s.status}`}>
                <Icon className="onboarding-step-icon" size={18} aria-hidden="true" />
                <span className="onboarding-step-text">
                  <span className="onboarding-step-title">
                    {s.title}
                    {!s.required && <span className="onboarding-step-optional"> (optional)</span>}
                  </span>
                  <span className="onboarding-step-desc">{s.description}</span>
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
      <div className="onboarding-actions">
        <Link className="btn btn-secondary btn-sm" to="/getting-started">See all</Link>
        {!user?.impersonating && (
          <button type="button" className="btn btn-sm onboarding-hide" onClick={() => setDismissed(true)}>
            Hide
          </button>
        )}
      </div>
    </section>
  );
}

export default OnboardingCard;
